import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

/**
 * NeoModal
 * Modal centralizado de alta fidelidade do NeoApp. Encapsula o visual
 * premium-modal com cabeçalhos com ícones circulares, Outfit e botões.
 */
const NeoModal = ({
    isOpen,
    toggle,
    title = '',
    subtitle = '',
    headerIcon = null,
    footerActions = null,
    children,
    size = 'md',
    centered = true,
    scrollable = true,
    className = '',
    contentClassName = '',
    bodyClassName = '',
    bodyStyle = {},
    footerClassName = '',
    ...props
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size={size}
            centered={centered}
            scrollable={scrollable}
            style={{ fontFamily: 'Outfit, sans-serif' }}
            className={`premium-modal ${className}`}
            contentClassName={`border-0 shadow-lg ${contentClassName}`}
            {...props}
        >
            <ModalHeader toggle={toggle} className="pb-3 border-bottom-0">
                <div className="d-flex align-items-center">
                    {headerIcon && (
                        <div className="modal-icon-bg bg-primary-soft me-3 animate__animated animate__zoomIn">
                            <i className={`mdi ${headerIcon} text-primary font-size-24`}></i>
                        </div>
                    )}
                    <div>
                        <span className="fw-bold text-dark font-size-15 d-block" style={{ color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                            {title}
                        </span>
                        {subtitle && (
                            <small className="text-muted font-size-11 fw-semibold d-block mt-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                {subtitle}
                            </small>
                        )}
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className={`p-4 pt-3 bg-white ${bodyClassName}`} style={{ fontFamily: 'Outfit, sans-serif', ...bodyStyle }}>
                {children}
            </ModalBody>
            {footerActions && (
                <ModalFooter className={`border-top-0 pt-0 bg-white rounded-bottom-4 px-4 pb-4 ${footerClassName}`}>
                    <div className="d-flex w-100 justify-content-end gap-2 align-items-center">
                        {footerActions}
                    </div>
                </ModalFooter>
            )}
        </Modal>
    );
};

NeoModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    headerIcon: PropTypes.string,
    footerActions: PropTypes.node,
    children: PropTypes.node,
    size: PropTypes.string,
    centered: PropTypes.bool,
    scrollable: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
    bodyStyle: PropTypes.object,
    footerClassName: PropTypes.string
};

export default NeoModal;
